(function ($, Drupal) {

  Drupal.behaviors.homepageCardIsLink = {
    attach: function (context, settings) {
      if ( $( ".link-wrapper" ).length ) {

        $(".link-wrapper .card--O").click(function () {
          window.location = $(this).find("a").attr("href");
          return false;
        });

        // cloning link to be over card
        $(".link-wrapper[data-class='smoothchange'] .cardgrid__content .layout__region").each(function() {
          var cardwrap = $(this).find('.card--O .card__wrap');
          var clonelink = $(this).find('.card--O .card__wrap .card__text a').clone().addClass("card__link");

          clonelink.appendTo(cardwrap);
        });
      }
    }
  };
})(jQuery, Drupal);
